import { render, staticRenderFns } from "./open_orders_widget.vue?vue&type=template&id=35239be0&scoped=true&"
import script from "./open_orders_widget.vue?vue&type=script&lang=js&"
export * from "./open_orders_widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35239be0",
  null
  
)

export default component.exports